module.exports = __webpack_public_path__ + "static/media/nc.b8c9f5e4.svg";